
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
} from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  @Prop({
    type: String,
    default: '标题',
  }) title?: string;

  @Model('change', { type: Boolean }) show!: boolean;

  change() {
    this.$emit('close');
  }
}
